"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToCard = void 0;
const session_utils_1 = require("./session-utils");
const mapToCard = (data) => {
    const { program, session, anytime, instructor, playlist } = data;
    if (program) {
        return mapToProgramCard(program);
    }
    if (session) {
        return mapToSessionCard(session);
    }
    if (anytime) {
        return mapToAnytimeCard(anytime);
    }
    if (instructor) {
        return mapToInstructorCard(instructor);
    }
    if (playlist) {
        return mapToPlaylistCard(playlist);
    }
};
exports.mapToCard = mapToCard;
const mapToProgramCard = (program) => {
    var _a, _b, _c;
    const bookedUsersSummary = Object.assign(Object.assign({}, program.bookedUsersSummary), { highlighted: (_a = program.bookedUsersSummary) === null || _a === void 0 ? void 0 : _a.highlighted.map((highlightedUser) => highlightedUser.imageUrl) });
    return {
        id: program.id,
        title: program.title,
        duration: program.duration,
        equipment: program.equipment,
        imageUrl: program.imageUrl,
        instructorId: program.instructorId,
        instructorName: program.instructor
            ? `${program.instructor.name.first} ${program.instructor.name.last}`
            : "",
        partnerTitle: (_c = (_b = program.instructor) === null || _b === void 0 ? void 0 : _b.partnerProfile) === null || _c === void 0 ? void 0 : _c.title,
        level: program.level,
        rating: program.rating,
        bookedUsersSummary,
        requiredProduct: program.requiredProduct,
    };
};
const mapToSessionCard = (session) => {
    var _a, _b, _c;
    const bookedUsersSummary = Object.assign(Object.assign({}, session.bookedUsersSummary), { highlighted: (_a = session.bookedUsersSummary) === null || _a === void 0 ? void 0 : _a.highlighted.map((highlightedUser) => highlightedUser.imageUrl) });
    const title = (0, session_utils_1.getSessionTitle)(session);
    const tags = (_b = session.program.programTags) === null || _b === void 0 ? void 0 : _b.map((tag) => tag.title);
    return {
        id: session.id,
        title,
        duration: session.program.duration,
        endTimestamp: new Date(session.end).getTime(),
        startTimestamp: new Date(session.start).getTime(),
        equipment: session.program.equipment,
        imageUrl: session.program.imageUrl,
        instructorId: session.program.instructorId,
        instructorName: `${session.program.instructor.name.first} ${session.program.instructor.name.last}`,
        partnerTitle: (_c = session.program.instructor.partnerProfile) === null || _c === void 0 ? void 0 : _c.title,
        level: session.program.level,
        programId: session.program.id,
        rating: session.program.rating,
        state: session.state,
        bookedUsersSummary,
        requiredProductLive: session.requiredProductLive,
        requiredProductAnytime: session.requiredProductAnytime,
        thumbnailUrl: session.thumbnailUrl,
        tags,
    };
};
const mapToAnytimeCard = (anytime) => {
    var _a, _b;
    const title = (0, session_utils_1.getSessionTitle)(anytime);
    const tags = (_a = anytime.program.programTags) === null || _a === void 0 ? void 0 : _a.map((tag) => tag.title);
    return {
        id: anytime.id,
        title,
        duration: anytime.program.duration,
        endTimestamp: new Date(anytime.end).getTime(),
        startTimestamp: new Date(anytime.start).getTime(),
        actualEndTimestamp: new Date(anytime.actualEndDate).getTime(),
        actualStartTimestamp: new Date(anytime.actualStartDate).getTime(),
        equipment: anytime.program.equipment,
        hlsUrl: anytime.hlsUrl,
        imageUrl: anytime.program.imageUrl,
        instructorId: anytime.program.instructorId,
        instructorName: `${anytime.program.instructor.name.first} ${anytime.program.instructor.name.last}`,
        partnerTitle: (_b = anytime.program.instructor.partnerProfile) === null || _b === void 0 ? void 0 : _b.title,
        level: anytime.program.level,
        mp4Url: anytime.mp4Url,
        programId: anytime.program.id,
        rating: anytime.program.rating,
        thumbnailUrl: anytime.thumbnailUrl,
        requiredProductLive: anytime.requiredProductLive,
        requiredProductAnytime: anytime.requiredProductAnytime,
        tags,
    };
};
const mapToInstructorCard = (instructor) => {
    var _a, _b;
    if (instructor)
        return {
            id: instructor.id,
            imageUrl: instructor.imageUrl,
            title: `${instructor.name.first} ${instructor.name.last}`,
            partnerTitle: (_a = instructor.partnerProfile) === null || _a === void 0 ? void 0 : _a.title,
            noOfFollowers: (_b = instructor.instructorProfile.followers) === null || _b === void 0 ? void 0 : _b.length,
            description: instructor.instructorProfile.title,
        };
};
const mapToPlaylistCard = (playlist) => {
    var _a;
    const tags = (_a = playlist.playlistTags) === null || _a === void 0 ? void 0 : _a.map((tag) => tag.title);
    return {
        id: playlist.id,
        title: playlist.title,
        imageUrl: playlist.imageUrl,
        tags,
    };
};
//# sourceMappingURL=mapToCard.js.map